<div class="header-upper">
  <div class="header-upper-inner">
    <a class="logo" *ngIf="headerData && headerData['logo']">
      <img src="{{ headerData['logo']?.data?.attributes?.url }}" />
    </a>
    <button *ngIf="auth.currentUser" class="logout-btn" (click)="auth.logout()">
      Logout
    </button>
  </div>
</div>
